import { useEffect } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import SidebarWithHeader from '~/components/SidebarWithHeader';
import Reports from '~/pages/private/reports';

import Reservations from '~/pages/private/reservations';
import { Settings } from '~/pages/private/settings';

import DeleteReservations from '~/pages/public/DeleteReservations';

import Login from '~/pages/public/Login';
import ProtectedRoute from './routes/ProtectedRoute';
import SuperAdminRoute from './routes/SuperAdminRoute';

import HeaderSuperAdmin from '~/components/HeaderSuperAdmin';
import SuperAdminSettings from '~/pages/private/superadmin/settings/Settings';
import LimpiarNegocios from '~/pages/private/superadmin/cleanup/LimpiarNegocios';
import { Forms } from '~/pages/public/Forms/Forms';
import TestForm from '~/pages/public/TestForm';
import PanelActividad from '~/pages/private/activity/ActividadPage';

const Router = () => {
  // This effect runs once, after the first render
  useEffect(() => {
    document.title = import.meta.env.VITE_APP_NAME;
  }, []);

  return (
    <Routes>
      <Route
        path='/'
        element={
          <ProtectedRoute>
            <SidebarWithHeader />
          </ProtectedRoute>
        }
      >
        <Route path={'/'} element={<Reservations />} />
        <Route path={'/reservas'} element={<Reservations />} />
        <Route path={'/reports'} element={<Reports />} />
        <Route path={'/settings'} element={<Settings />} />
        <Route path={'/actividad'} element={<PanelActividad />} />
      </Route>
      {/* Zona del superadministrador. Antes bastaba con tener sesión, así que
          el administrador de cualquier cliente podía ver los negocios, los
          usuarios y los registros de todos los demás. */}
      <Route
        path='/admin'
        element={
          <SuperAdminRoute>
            <HeaderSuperAdmin />
          </SuperAdminRoute>
        }
      >
        <Route path={''} element={<SuperAdminSettings />} />
        {/* Limpieza de negocios que ya no operan. La propia pantalla vuelve a
            comprobar el rol antes de mostrar nada. */}
        <Route path={'delete-old'} element={<LimpiarNegocios />} />
      </Route>
      <Route path={'/form/:externalId'} element={<Forms />} />
      <Route path={'/reservations/:externalId/:code'} element={<Forms />} />
      <Route path={'/login'} element={<Login />} />
      {/* Limpieza de agenda: exige haber iniciado sesión. Antes era pública y
          cualquiera con la URL podía vaciar los horarios de todas las sedes. */}
      <Route
        path={'/delete'}
        element={
          <ProtectedRoute>
            <DeleteReservations />
          </ProtectedRoute>
        }
      />
      <Route path={'/test'} element={<TestForm />} />

      {/* Cualquier dirección desconocida lleva al inicio en vez de dejar la
          pantalla en blanco. Hace falta sobre todo por los enlaces guardados a
          /leads y /surveys, que se retiraron al no usarse. */}
      <Route path='*' element={<Navigate to='/' replace />} />
    </Routes>
  );
};

export default Router;
